module.exports = __webpack_public_path__ + "img/emsbanner4.dd9206db.png";